import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import BottomNav from "@/components/BottomNav";

export default function AppShell() {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const hideNav = pathname.startsWith("/app/coach");
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.onboarding_complete) return <Navigate to="/onboarding" replace />;
  return (
    <div className="min-h-screen bg-slate-50">
      <div className={`max-w-md mx-auto bg-white min-h-screen relative shadow-[0_0_60px_rgba(15,23,42,0.05)] ${hideNav ? "" : "pb-24"}`}>
        <Outlet />
        {!hideNav && <BottomNav />}
      </div>
    </div>
  );
}
